import { clsx } from 'clsx';

import type { LabelHTMLAttributes } from 'react';

import styles from './Label.module.css';

export interface LabelProps extends Omit<LabelHTMLAttributes<HTMLLabelElement>, 'className' | 'style'> {
  /** The id of the element for which the label is intended. */
  htmlFor: string;
  /** `true` if the font-weight needs to be unset; otherwise, `false`. The default is `false`. */
  noFontWeight?: boolean;
  /** `true` to show an asterisk to indicate an item is required; otherwise, `false`. */
  required?: boolean;
  /** `true` to align text right; otherwise, `false`. */
  alignRight?: boolean;
}

/** Represents a component that renders a label for an input element. */
export const Label = ({ children, htmlFor, noFontWeight, required = false, alignRight, ...restProps }: LabelProps) => (
  <label
    {...restProps}
    htmlFor={htmlFor}
    className={clsx(styles['label'], {
      [styles['label--unset-font-weight']]: noFontWeight,
      [styles['label--required']]: required,
      [styles['label--align-right']]: alignRight,
    })}
  >
    {children}
  </label>
);
